<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!--<div class="common-page-contentwrap">-->
  <div class="">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
            <li><a>Manage</a></li>
            <li><a>User Setting</a></li>
            <li><a>Sync</a></li>
          </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
      <!-- START FORM VALIDATION STATES -->
      <div class="block">
        <div class="col-lg-12">
          <button id="culturesummaryreportsearch" class="mapdevice_submit btn btn-info update btn_color"
                (click)="aclSync()"  type="submit">Sync
          </button>
        </div>
      </div>
      <!-- END FORM VALIDATION STATES -->

    </div>
  </div>
  <!-- END PAGE CONTENT WRAPPER -->
</div>
<!-- END PAGE CONTENT WRAPPER -->

